import { ApiResponse } from '../models';
import {
  VehicleSalesTarget,
  VehicleSalesTargetData,
  VehicleSalesTargetDataFiles,
} from '../models/vehicleSalesTarget';
import * as http from './http';
import ApiService from './service';

export class VehicleSalesTargetService extends ApiService {
  public async createSalesTarget(data: VehicleSalesTarget) {
    const url = `${this.apiDomain}/api/vehicle-sales-target/create`;

    const response = await http.post<VehicleSalesTarget>(url, data, this.store);
    return response.data;
  }

  public async loadSalesTarget() {
    const url = `${this.apiDomain}/api/vehicle-sales-target/targets`;

    const resposne = await http.get<ApiResponse<VehicleSalesTarget[]>>(
      url,
      this.store
    );
    return resposne?.data;
  }

  public async getSalesTargetDetails(
    id: string
  ): Promise<VehicleSalesTargetData> {
    const url = `${this.apiDomain}/api/vehicle-sales-target/${id}`;

    const resposne = await http.get<VehicleSalesTargetData>(url, this.store);
    return resposne?.data;
  }

  public async updateSalesTargetBasic(
    id: string,
    targetDate: Date,
    title?: string
  ) {
    const url = `${this.apiDomain}/api/vehicle-sales-target/${id}`;

    const resposne = await http.put<VehicleSalesTarget>(
      url,
      {
        title,
        targetDate,
      },
      this.store
    );
    return resposne?.data;
  }

  public async updateSalesTarget(
    id: string,
    targetData: VehicleSalesTargetDataFiles[]
  ) {
    const url = `${this.apiDomain}/api/vehicle-sales-target/${id}/target`;

    const resposne = await http.put<VehicleSalesTarget>(
      url,
      {
        targetData,
      },
      this.store
    );
    return resposne?.data;
  }

  public async bulkUpdateSalesTarget(
    id: string,
    targetData?: VehicleSalesTargetDataFiles[]
  ) {
    const url = `${this.apiDomain}/api/vehicle-sales-target/${id}/target`;

    const resposne = await http.put<VehicleSalesTarget>(
      url,
      {
        targetData,
      },
      this.store
    );
    return resposne?.data;
  }

  public async downloadSalesTarget(id: string) {
    const url = `${this.apiDomain}/api/vehicle-sales-target/${id}/download`;
    const reponse = await http.download(url, this.store);
    http.saveDownloadedFile(
      reponse.data,
      'application/pdf',
      `${'VehicleSalesTarget'}.xlsx`
    );
    return;
  }
}
